import React from 'react'
import AssetCheckin from '../../components/assettransfercomponents/AssetCheckin'

function AssetChechInForm({renderPageContent}) {
    return (
       <>
       <AssetCheckin renderPageContent={renderPageContent}/>
       </>
    )
}

export default AssetChechInForm
